import React from "react";
import type { BookingItem } from "./preneed-booking.types";
import dayjs from "dayjs";

type Props = {
  booking: BookingItem;
  onViewDetails: (bookingId: string) => void; //  bookingId from API (#ORD...)
};

const statusClass = (s: BookingItem["status"]) => {
  switch (s) {
    case "Confirmed":
      return "mg-status mg-status--confirmed";
    case "Cancelled":
      return "mg-status mg-status--cancelled";
    case "Completed":
      return "mg-status mg-status--completed";
    case "Pending":
    default:
      return "mg-status mg-status--pending";
  }
};

export default function PreneedCalendarBooking({ booking, onViewDetails }: Props) {
  const idForDetails = booking.bookingId || booking.id; //  prefer bookingId
  console.log("Rendering booking card for bookingId:", booking, "with id:", booking.id);
  return (
    <div className="mg-bookingCard">
      <div className="mg-bookingCard__top">
        <div className="mg-bookingCard__name">{booking.customerName}</div>
        <span className={statusClass(booking.status)}>{booking.status}</span>
      </div>

      <div className="mg-bookingCard__service">{booking.packageType}</div>

      <div className="mg-bookingCard__grid">
        <div className="mg-field">
          <div className="mg-field__label">Amount Paid</div>
          <div className="mg-field__value">
            ${Number(booking.amountPaid || 0).toLocaleString()}
          </div>
        </div>

        <div className="mg-field">
          <div className="mg-field__label">Ordered Date</div>
          <div className="mg-field__value">{booking.dateOfRequest}</div>
        </div>

        <div className="mg-field">
          <div className="mg-field__label">Appointment Date</div>
          <div className="mg-field__value">
            {booking.appointmentDate && booking.appointmentDate !== "-"
              ? dayjs(booking.appointmentDate).format("MMM DD, YYYY")
              : "-"}
          </div>
        </div>

        <div className="mg-field">
          <div className="mg-field__label">Appointment Time</div>
          <div className="mg-field__value">{booking.appointmentTime}</div>
        </div>
      </div>

      <button
        type="button"
        className="mg-link"
        onClick={() => onViewDetails(idForDetails)}
      >
        View Details →
      </button>
    </div>
  );
}
